// ─────────────────────────────────────────────────────────────────────────────
// Niveau d'un employé dans sa classe salariale — fonctions pures, importables
// côté client (aucun Firestore). Le niveau est un RÔLE persisté sur
// pulse_compensation.current_niveau (FK par valeur vers
// SalaryClassNiveau.level) : il ne se déduit PAS de l'échelon, les plages des
// niveaux se chevauchant aux bas échelons. Chaque niveau plafonne l'avancement
// via echelon_max.
// ─────────────────────────────────────────────────────────────────────────────

import type { SalaryClass, SalaryClassNiveau } from '../types/firestore'

export const NIVEAU_NON_DEFINI = 'Niveau non défini'

export function resolveNiveau(
  niveaux: SalaryClassNiveau[],
  level: number | null,
): SalaryClassNiveau | null {
  if (level == null) return null
  return niveaux.find((n) => n.level === level) ?? null
}

// Échelon maximal atteignable : niveau non défini ou echelon_max null ⇒ toute
// l'échelle de la classe.
export function maxEchelonForNiveau(
  cls: Pick<SalaryClass, 'echelons' | 'niveaux'>,
  level: number | null,
): number {
  return resolveNiveau(cls.niveaux, level)?.echelon_max ?? cls.echelons.length
}

export function niveauOptionLabel(n: Pick<SalaryClassNiveau, 'level' | 'label'>): string {
  return `Niveau ${n.level} — ${n.label}`
}

// Libellé court d'affichage : « Niveau 2 — Chargé de projet / Surintendant »
// ou « Niveau non défini ».
export function niveauDisplayLabel(
  niveaux: SalaryClassNiveau[],
  level: number | null,
): string {
  const n = resolveNiveau(niveaux, level)
  return n ? niveauOptionLabel(n) : NIVEAU_NON_DEFINI
}
